














































import { Component, Vue } from "vue-property-decorator";
import { EmojiPicker } from "vue-emoji-picker";

@Component({
  components: {
    EmojiPicker,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
})
export default class MessagesSendingFormEmojiPicker extends Vue {
  data() {
    return {
      input: "",
      search: "",
    };
  }

  append(emoji: string) {
    this.$emit("picked", emoji);
  }
}
